module.exports = {
          srcSet: __webpack_public_path__ + "906c429715aa2819fef2d245762bf8f6-560.png"+" 560w",
          images:[ {path: __webpack_public_path__ + "906c429715aa2819fef2d245762bf8f6-560.png",width: 560,height: 443}],
          src: __webpack_public_path__ + "906c429715aa2819fef2d245762bf8f6-560.png",
          toString:function(){return __webpack_public_path__ + "906c429715aa2819fef2d245762bf8f6-560.png"},
          
          width: 560,
          height: 443
        }